import { useTheme } from '@mui/material';
import { DetailItem, ItemListCard } from 'components/ItemListCard';
import { getTrans } from 'modules/i18n';
import { CVBuilderFormValues } from 'utils/cv-form-db';
import { formatDateForDisplay } from './utils';

export const ProfessionalExperienceDetailsList = ({
  values,
  onAddClick,
  onEditExperience,
  onDeleteExperience
}: {
  values: CVBuilderFormValues;
  onAddClick: () => void;
  onEditExperience?: (index: number) => void;
  onDeleteExperience?: (index: number) => void;
}) => {
  const theme = useTheme();

  const experienceMissing = !values.professionalExperience?.length;

  return (
    <ItemListCard
      isEmpty={experienceMissing}
      showAddButton={true}
      addButtonLabel={getTrans(
        'cvBuilderPage.professionalExperience.button.addExperience.label'
      )}
      addButtonTestId="show-add-education-form-button"
      onAddClick={onAddClick}
      emptyStateText={
        experienceMissing
          ? getTrans(
              'cvBuilderPage.professionalExperience.button.addExperience.body'
            )
          : undefined
      }
      sx={{
        [theme.breakpoints.up('sm')]: {
          pb: 3
        },
        pb: 3
      }}
    >
      {values.professionalExperience?.map((exp, index) => (
        <DetailItem
          onEditItem={() => onEditExperience?.(index)}
          onDeleteItem={() => onDeleteExperience?.(index)}
          key={index}
          title={`${exp.position} ${getTrans('general.at')} ${exp.companyName}`}
          details={[
            {
              value: `${formatDateForDisplay(exp.startDate || '')} - ${
                exp.currentlyWorking
                  ? getTrans(
                      'cvBuilderPage.professionalExperience.item.currentlyWorking.label'
                    )
                  : formatDateForDisplay(exp.endDate || '')
              }`
            },
            {
              value: exp.description
            }
          ]}
          sx={{ pb: 1 }}
        />
      ))}
    </ItemListCard>
  );
};
